import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English translations
const enTranslations = {
  // Navigation
  nav: {
    home: 'Home',
    cases: 'Cases',
    about: 'About',
    faq: 'FAQ',
    bookConsultation: 'Book Consultation'
  },
  
  // Home page
  home: {
    heroTitle1: 'Trusted Global Property',
    heroTitle2: 'Investments',
    heroSubtitle: 'Connecting you to premium real estate opportunities across Europe and Asia.',
    exploreCases: 'Explore Cases',
    whyChoose: 'Why Choose Fundora',
    whyChooseSubtitle: 'Your trusted partner in global real estate investment',
    trustExperience: 'Trust & Experience',
    trustExperienceDesc: 'Over 10 years of international investment experience with a proven track record since 1998. All payments go directly to developers for maximum security.',
    globalReach: 'Global Reach',
    globalReachDesc: 'Exclusive access to premium properties across Northern Cyprus, Indonesia, Vietnam, and Maldives with local expertise.',
    sustainableGrowth: 'Sustainable Growth',
    sustainableGrowthDesc: 'Strategic investment opportunities designed for long-term value appreciation and portfolio diversification.',
    featuredCases: 'Featured Cases',
    featuredCasesSubtitle: 'Handpicked investment opportunities from our global portfolio',
    viewAll: 'View All',
    viewAllCases: 'View All Cases',
    investmentRegions: 'Investment Regions',
    investmentRegionsSubtitle: 'Explore opportunities in the world\'s most sought-after destinations',
    readyToInvest: 'Ready to Invest Globally?',
    readyToInvestDesc: 'Get personalized advice and discover the best international real estate opportunities tailored to your investment goals.',
    bookAConsultation: 'Book a Consultation'
  },
  
  // About page
  about: {
    title: 'About Fundora',
    subtitle: 'Your trusted partner in global real estate investment since 1998',
    ourMission: 'Our Mission',
    missionText1: 'Fundora is an international real estate investment intermediary brand that connects investors with high-quality property opportunities around the world.',
    missionText2: 'Our mission is to help clients achieve sustainable value growth through smart real estate investments in carefully selected markets across Europe and Asia.',
    missionText3: 'Registered in Lithuania (EU) since 1998, we bring over two decades of expertise, integrity, and a commitment to excellence in every transaction.',
    coreValues: 'Our Core Values',
    coreValuesSubtitle: 'The principles that guide every decision we make',
    reliability: 'Reliability',
    reliabilityDesc: 'Trust and transparency in every transaction. All payments go directly to developers.',
    globalReachValue: 'Global Reach',
    globalReachValueDesc: 'Access to premium properties across Europe and Asia with local expertise.',
    growth: 'Growth',
    growthDesc: 'Strategic investments designed for long-term value appreciation.',
    clientFocused: 'Client-Focused',
    clientFocusedDesc: 'Personalized service tailored to your unique investment goals.',
    ourApproach: 'Our Approach',
    expertVerification: 'Expert Verification',
    expertVerificationDesc: 'Every property in our portfolio is personally vetted by our experienced team. We only present opportunities we would invest in ourselves.',
    directPartnerships: 'Direct Partnerships',
    directPartnershipsDesc: 'We work directly with reputable developers and property owners, ensuring you get the best prices and terms without unnecessary intermediaries.',
    endToEndSupport: 'End-to-End Support',
    endToEndSupportDesc: 'From initial consultation to property management, we provide comprehensive support throughout your investment journey.',
    investWithConfidence: 'Invest with Confidence',
    investWithConfidenceDesc: 'Join us in discovering exceptional real estate investment opportunities. As active investors ourselves, we only present properties we believe in and would invest in personally.'
  },
  
  // Cases/Properties page
  cases: {
    title: 'Investment Cases',
    subtitle: 'Browse our curated selection of premium properties across Europe and Asia',
    searchPlaceholder: 'Search by title or location...',
    allRegions: 'All Regions',
    allTypes: 'All Types',
    villa: 'Villa',
    apartment: 'Apartment',
    clearFilters: 'Clear Filters',
    whyInvest: 'Why Invest in',
    showing: 'Showing',
    casesCount: 'cases',
    noResults: 'No cases found matching your criteria.',
    clearAllFilters: 'Clear All Filters'
  },
  
  // FAQ page
  faq: {
    title: 'Frequently Asked Questions',
    subtitle: 'Find answers to common questions about investing with Fundora',
    stillHaveQuestions: 'Still Have Questions?',
    stillHaveQuestionsDesc: 'Our team is here to help. Schedule a consultation and we\'ll answer all your questions.',
    contactUs: 'Contact Us',
    questions: {
      q1: 'What is Fundora?',
      a1: 'Fundora is an international real estate investment intermediary brand connecting investors with high-quality property opportunities across Europe and Asia. We\'ve been registered in Lithuania (EU) since 1998.',
      q2: 'Can I invest in properties abroad?',
      a2: 'Yes! We specialize in helping international investors acquire properties in Northern Cyprus, Indonesia, Vietnam, and Maldives. Our team handles all the complexities of cross-border transactions.',
      q3: 'Can I buy property remotely?',
      a3: 'Absolutely. We facilitate remote purchases with comprehensive virtual tours, legal support, and secure payment processes. Many of our clients successfully invest without visiting the property in person.',
      q4: 'What makes Fundora different?',
      a4: 'We combine over 10 years of international investment experience with a carefully vetted network of partners. We only present properties we believe in and ensure all payments go directly to developers for maximum security.',
      q5: 'How can I trust Fundora?',
      a5: 'Trust is our foundation. All payments go directly to property developers, never through intermediaries. We provide full transparency, legal support, and have a proven track record since 1998.',
      q6: 'Do you manage properties?',
      a6: 'Yes, we partner with trusted local property management companies to handle maintenance, rentals, and ongoing care of your investment.',
      q7: 'Is Fundora only for large investors?',
      a7: 'Not at all. We work with investors of all sizes, from first-time buyers to seasoned portfolio managers. Our mission is to make global real estate investment accessible to everyone.'
    }
  },
  
  // Contact page
  contact: {
    title: 'Book a Consultation',
    subtitle: 'Let\'s discuss your investment goals and find the perfect property for you',
    getInTouch: 'Get in Touch',
    fullName: 'Full Name',
    fullNamePlaceholder: 'John Doe',
    email: 'Email Address',
    emailPlaceholder: 'john@example.com',
    phone: 'Phone Number',
    phonePlaceholder: '+1 234 567 8900',
    interestedRegion: 'Interested Region',
    selectRegion: 'Select a region',
    northernCyprus: 'Northern Cyprus',
    indonesia: 'Indonesia',
    vietnam: 'Vietnam',
    maldives: 'Maldives',
    multipleRegions: 'Multiple Regions',
    upcomingTitle: 'Upcoming Consultations',
    nextConsultation: 'Next consultation',
    upcomingSubtitle: 'Reserve your place in one of our upcoming online investment consultations',
    onlineConsultation: 'Online Investment Consultation',
    reserve: 'Reserve',
    indonesiaFull: 'Bali, Indonesia',
    pickDate: 'Choose a consultation date',
    pickDateDesc: 'Available online consultations for this region',
    consultationDate: 'Consultation Date',
    selectDate: 'Select a date',
    changeDate: 'Change',
    noDates: 'No dates scheduled yet — we\'ll contact you to arrange one',
    continueAnyway: 'Continue',
    regTitle: 'Reserve your place',
    regSubtitle: 'A few details and your seat is confirmed',
    regDetails: 'Consultation details',
    regConsultationId: 'Consultation ID',
    regFormat: 'Format',
    regFormatValue: 'Online via Google Meet',
    regTimeNote: 'Vilnius time (EET/EEST)',
    regName: 'Full name',
    regEmail: 'Email address',
    regPhone: 'Phone number',
    regCountry: 'Country of residence',
    regCountryPlaceholder: 'Lithuania',
    regConfirm: 'Confirm registration',
    regSubmitting: 'Confirming...',
    regPrivacy: 'We use your details only to confirm this consultation. No spam, ever.',
    regThanksTitle: 'Registration confirmed',
    regThanksBody: 'Thank you for registering for the {{region}} investment consultation.',
    regThanksEmail: 'The joining information and the Google Meet link have been sent to your email. Please check your inbox. If you do not see the message within a few minutes, check your spam or promotions folder.',
    regThanksClosing: 'We look forward to meeting you.',
    regBackHome: 'Back to home',
    regBrowse: 'Browse projects',
    regUnavailable: 'This consultation is no longer available',
    regUnavailableDesc: 'The date may have already passed. Have a look at the upcoming consultations.',
    regSeeUpcoming: 'See upcoming consultations',
    regError: 'Registration failed. Please check your details and try again.',
    message: 'Message',
    messagePlaceholder: 'Tell us about your investment goals and preferences...',
    sendMessage: 'Send Message',
    sending: 'Sending...',
    contactInfo: 'Contact Information',
    contactInfoDesc: 'Have questions? Reach out to us through any of these channels, and our team will get back to you promptly.',
    emailLabel: 'Email',
    respondTime: 'We\'ll respond within 24 hours',
    phoneLabel: 'Phone',
    phoneHours: 'Mon-Fri, 9:00 - 18:00',
    office: 'Office',
    messageSent: 'Message Sent!',
    messageSentDesc: 'Thank you for your interest. We\'ll contact you within 24 hours.',
    error: 'Error',
    errorMessage: 'Failed to send message. Please try again.'
  },
  
  // Privacy Policy page
  privacy: {
    title: 'Privacy Policy',
    subtitle: 'Fundora Real Estate - Privacy Policy for Lead Collection',
    effectiveDate: 'Effective Date: July 11, 2025',
    intro: 'Fundora Real Estate ("we," "us," or "our") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, store, and protect the information you provide when you respond to our advertisements or submit your details through Facebook or Instagram lead forms.',
    section1Title: '1. Information We Collect',
    section1Text: 'When you interact with our ad campaign and voluntarily fill out the form, we may collect the following personal information:',
    section1List: ['Full name', 'Email address', 'Phone number'],
    section1Footer: 'We collect this data solely for the purposes outlined below and only with your consent.',
    section2Title: '2. How We Use Your Information',
    section2Text: 'We use your personal data for the following purposes:',
    section2List: [
      'To contact you regarding real estate investment opportunities that may interest you',
      'To provide personalized information and updates about our services',
      'To respond to inquiries or requests you have submitted',
      'To comply with any legal obligations'
    ],
    section2Footer: 'Your information will not be sold, rented, or shared with third parties for their marketing purposes.',
    section3Title: '3. Legal Basis for Processing',
    section3Text: 'Our processing of your personal data is based on your explicit consent, which you provide when submitting your details through the lead form. You can withdraw your consent at any time by contacting us (see Section 6).',
    section4Title: '4. Data Retention',
    section4Text: 'We will retain your personal data only for as long as necessary to fulfill the purposes outlined in this policy or as required by applicable laws. If you withdraw your consent, your information will be deleted or anonymized promptly.',
    section5Title: '5. Data Security',
    section5Text: 'We implement appropriate technical and organizational measures to protect your personal data from unauthorized access, disclosure, alteration, or destruction. Access to your data is restricted to authorized personnel only.',
    section6Title: '6. Your Rights',
    section6Text: 'You have the right to:',
    section6List: [
      'Access the personal data we hold about you',
      'Request correction of inaccurate data',
      'Request deletion of your data',
      'Withdraw your consent at any time',
      'Lodge a complaint with a data protection authority if you believe your rights have been violated'
    ],
    section6Footer: 'To exercise any of these rights, please contact us at:',
    section7Title: '7. Third-Party Platforms',
    section7Text: 'This Privacy Policy applies only to data collected through Facebook and Instagram lead forms. Please note that Facebook and Instagram are owned by Meta Platforms, Inc., and your use of those platforms is also subject to Meta\'s Data Policy, available at:',
    section7Footer: 'We do not assume responsibility for Meta\'s data handling practices but ensure that our use of your data complies with their platform policies.',
    section8Title: '8. Updates to This Policy',
    section8Text: 'We may update this Privacy Policy from time to time. Any changes will be posted here with an updated "Effective Date." We encourage you to review this policy periodically.',
    section8Footer: 'If you have any questions or concerns regarding this Privacy Policy, please contact us at the email provided above.',
    questionsTitle: 'Questions About Our Privacy Policy?',
    questionsText: 'If you have any questions or concerns, please don\'t hesitate to contact us.'
  },
  
  // Newsletter component
  newsletter: {
    title: 'Stay Updated with Latest Opportunities',
    subtitle: 'Subscribe to receive exclusive property listings, market insights, and investment tips directly to your inbox.',
    placeholder: 'Enter your email',
    subscribe: 'Subscribe',
    subscribing: 'Subscribing...',
    subscribed: 'Subscribed!',
    subscribedDesc: 'Thank you for subscribing to our newsletter.',
    error: 'Error',
    errorMessage: 'Failed to subscribe. Please try again.'
  },
  
  // Footer
  footer: {
    description: 'Connecting investors to premium real estate opportunities across Europe and Asia since 1998.',
    quickLinks: 'Quick Links',
    ourRegions: 'Our Regions',
    contact: 'Contact',
    copyright: '© {{year}} Fundora. All rights reserved.'
  },
  
  // Property Card
  property: {
    featured: 'Featured',
    apartments: 'Apartments',
    villas: 'Villas',
    beds: 'Beds',
    baths: 'Baths',
    from: 'From',
    villa: 'Villa',
    apartment: 'Apartment',
    mixed: 'Mixed',
    studio: 'Studio',
    terrace: 'terrace',
    balcony: 'balcony'
  },
  
  // Property Descriptions
  properties: {
    1: {
      description: 'This is a modern complex with an ALL IN ONE concept, where everything you need is gathered in one place. The "All in One" concept allows you to enjoy restaurants, shopping, activities, and entertainment without ever leaving the complex!'
    },
    2: {
      description: 'The well-developed infrastructure of the complex creates comfortable conditions for living and recreation, increasing the attractiveness of the property both for residence and for investment.'
    },
    3: {
      description: "Volcanoes are one of the most striking features of Bali's landscape, surrounded by numerous myths and legends that still attract hundreds of thousands of tourists from all over the world to experience the spirit of the mountains. In this project, attention is given to volcanic rock and multilayered lighting, reflecting the impressive and dynamic nature of an erupting volcano."
    },
    4: {
      description: "Apartments — high demand for both living and renting. Only 300 m or 3 minutes' walk to the popular Finns and Atlas beaches and clubs. Berawa — the most sought-after area in Bali with high tourist traffic. Large complex with infrastructure and a rooftop with panoramic views. High liquidity and steady price growth."
    },
    6: {
      description: 'An upscale hotel complex located on the first line of the ocean, surrounded by lagoons with crystal-clear water. Each unit offers scenic views with direct outlooks over the ocean and sunsets.'
    },
    7: {
      description: 'A seaside urban area in the middle of a livable city. It is a second home of millions of Vietnamese people who love the sea. A stalwart 44ha city standing tall, embracing the Heavenly Paradise Bay, igniting a promising future for a northern voyage.'
    },
    8: {
      description: 'This is not just real estate — it is a carefully designed residential complex, fully adapted to the local culture and religious principles. Such a unique solution ensures constant demand and makes this project an exceptional investment opportunity on the island.'
    },
    9: {
      description: 'Just 100 meters from the beach, MALIBU offers unparalleled access to Mediterranean shores. Located in Esentepe, the complex combines natural beauty with modern convenience.'
    },
    12: {
      description: 'A stable investment project with hotel management, a guaranteed model, and well-developed infrastructure — suitable for both income generation and long-term value.'
    }
  },
  
  // Property Detail Page
  propertyDetail: {
    backToCases: 'Back to Cases',
    price: 'Price',
    keyDetails: 'Key Details',
    location: 'Location',
    propertyType: 'Property Type',
    address: 'Address',
    description: 'About This Property',
    interested: 'Interested in this property?',
    getAdvice: 'Get personalized advice and discover how this property fits your investment goals.',
    directPayments: 'Direct payments to developers',
    legalSupport: 'Full legal support',
    remoteAvailable: 'Remote purchase available',
    browseMore: 'Browse all cases',
    notFound: 'Property not found'
  },
  
  // Regions
  regions: {
    northernCyprus: {
      name: 'Northern Cyprus',
      description: 'Modern apartments and studios with investment opportunities',
      count: '3 Properties',
      investmentInfo: 'Northern Cyprus combines stunning Mediterranean coastlines with unspoiled natural beauty at prices significantly lower than both Southern Cyprus and Western Europe. The growing tourism sector and increasing international recognition create strong potential for capital appreciation. With beautiful beaches, mountain landscapes, and a straightforward purchase process for foreigners, it\'s an increasingly popular choice for investors seeking affordable Mediterranean luxury.'
    },
    bali: {
      name: 'Bali (Indonesia)',
      description: 'Tropical paradise villas and apartments in Bali',
      count: '4 Properties',
      investmentInfo: 'Bali\'s real estate market offers exceptional returns driven by year-round tourism and a thriving digital nomad community. The island\'s unique culture, affordable living costs, and tropical climate attract millions of visitors annually, ensuring consistent rental demand. Indonesian property laws favor long-term leasehold arrangements that provide security while keeping entry costs accessible for international investors.'
    },
    vietnam: {
      name: 'Vietnam',
      description: 'Modern apartments and luxury developments',
      count: '1 Property',
      investmentInfo: 'Vietnam\'s rapidly growing economy and emerging middle class create strong demand for quality housing. Coastal cities like Nha Trang offer beachfront properties at attractive prices with significant growth potential. The country\'s political stability, improving infrastructure, and increasing foreign investment make it one of Southeast Asia\'s most promising real estate markets.'
    },
    maldives: {
      name: 'Maldives',
      description: 'Ultra-luxury island properties and resort investments',
      count: '1 Property',
      investmentInfo: 'The Maldives represents the pinnacle of luxury tropical real estate with exclusive resort properties and oceanfront developments. As one of the world\'s premier tourist destinations, properties here benefit from ultra-high-net-worth clientele and exceptional rental yields. The government\'s focus on sustainable tourism and limited development opportunities ensure exclusivity and long-term value appreciation.'
    }
  }
};

// Lithuanian translations
const ltTranslations = {
  // Navigation
  nav: {
    home: 'Pradžia',
    cases: 'Objektai',
    about: 'Apie mus',
    faq: 'DUK',
    bookConsultation: 'Užsisakyti konsultaciją'
  },
  
  // Home page
  home: {
    heroTitle1: 'Patikimos investicijos į užsienio',
    heroTitle2: 'nekilnojamąjį turtą',
    heroSubtitle: 'Sujungiame jus su aukščiausios kokybės nekilnojamojo turto galimybėmis Europoje ir Azijoje.',
    exploreCases: 'Peržiūrėti objektus',
    whyChoose: 'Kodėl verta rinktis Fundora',
    whyChooseSubtitle: 'Jūsų patikimas partneris investuojant į nekilnojamąjį turtą',
    trustExperience: 'Pasitikėjimas ir patirtis',
    trustExperienceDesc: 'Daugiau nei 10 metų tarptautinių investicijų patirties su įrodyta sėkme nuo 1998 m. Visi mokėjimai atliekami tiesiogiai vystytojams maksimaliam saugumui.',
    globalReach: 'Pasaulinis tinklas',
    globalReachDesc: 'Išskirtinė prieiga prie aukščiausios kokybės nekilnojamojo turto Šiaurės Kipre, Indonezijoje, Vietname ir Maldyvuose su vietine patirtimi.',
    sustainableGrowth: 'Tvarus augimas',
    sustainableGrowthDesc: 'Strateginės investavimo galimybės, sukurtos ilgalaikiam vertės augimui ir portfelio diversifikavimui.',
    featuredCases: 'Rekomenduojami objektai',
    featuredCasesSubtitle: 'Atrinktos investavimo galimybės iš mūsų pasaulinio portfelio',
    viewAll: 'Žiūrėti visus',
    viewAllCases: 'Žiūrėti visus objektus',
    investmentRegions: 'Investicijų regionai',
    investmentRegionsSubtitle: 'Atraskite galimybes labiausiai pageidaujamose pasaulio vietose',
    readyToInvest: 'Pasiruošę investuoti globaliai?',
    readyToInvestDesc: 'Gaukite asmeninę konsultaciją ir atraskite geriausias tarptautines nekilnojamojo turto galimybes, pritaikytas jūsų investavimo tikslams.',
    bookAConsultation: 'Užsisakyti konsultaciją'
  },
  
  // About page
  about: {
    title: 'Apie Fundora',
    subtitle: 'Jūsų patikimas partneris investuojant į nekilnojamąjį turtą nuo 1998 m.',
    ourMission: 'Mūsų misija',
    missionText1: 'Fundora yra tarptautinis nekilnojamojo turto investicijų tarpininkas, jungiantis investuotojus su aukštos kokybės nekilnojamojo turto galimybėmis visame pasaulyje.',
    missionText2: 'Mūsų misija – padėti klientams pasiekti tvarų vertės augimą per protingas investicijas į nekilnojamąjį turtą kruopščiai atrinktose Europos ir Azijos rinkose.',
    missionText3: 'Registruoti Lietuvoje (ES) nuo 1998 m., mes turime daugiau nei du dešimtmečius patirties, sąžiningumo ir įsipareigojimo tobulumui kiekvienoje transakcijoje.',
    coreValues: 'Mūsų pagrindinės vertybės',
    coreValuesSubtitle: 'Principai, kuriais vadovaujamės priimdami kiekvieną sprendimą',
    reliability: 'Patikimumas',
    reliabilityDesc: 'Pasitikėjimas ir skaidrumas kiekvienoje transakcijoje. Visi mokėjimai atliekami tiesiogiai vystytojams.',
    globalReachValue: 'Pasaulinis tinklas',
    globalReachValueDesc: 'Prieiga prie aukščiausios kokybės nekilnojamojo turto Europoje ir Azijoje su vietine patirtimi.',
    growth: 'Augimas',
    growthDesc: 'Strateginės investicijos, sukurtos ilgalaikiam vertės augimui.',
    clientFocused: 'Orientacija į klientą',
    clientFocusedDesc: 'Asmeninis aptarnavimas, pritaikytas jūsų unikaliems investavimo tikslams.',
    ourApproach: 'Mūsų požiūris',
    expertVerification: 'Ekspertų patikrinimas',
    expertVerificationDesc: 'Kiekvienas mūsų portfelyje esantis turtas yra asmeniškai patikrintas mūsų patyrusios komandos. Mes pateikiame tik tas galimybes, į kurias patys investuotume.',
    directPartnerships: 'Tiesioginės partnerystės',
    directPartnershipsDesc: 'Dirbame tiesiogiai su patikimais vystytojais ir turto savininkais, užtikrindami, kad gausite geriausias kainas ir sąlygas be nereikalingų tarpininkų.',
    endToEndSupport: 'Visapusiška pagalba',
    endToEndSupportDesc: 'Nuo pradinės konsultacijos iki turto valdymo – teikiame visapusišką pagalbą visos jūsų investicijų kelionės metu.',
    investWithConfidence: 'Investuokite su pasitikėjimu',
    investWithConfidenceDesc: 'Prisijunkite prie mūsų atrandant išskirtines nekilnojamojo turto investavimo galimybes. Kaip aktyvūs investuotojai, mes pateikiame tik tuos objektus, kuriais tikime ir į kuriuos patys investuotume.'
  },
  
  // Cases/Properties page
  cases: {
    title: 'Investiciniai objektai',
    subtitle: 'Peržiūrėkite mūsų atrinktą aukščiausios kokybės nekilnojamojo turto pasirinkimą Europoje ir Azijoje',
    searchPlaceholder: 'Ieškoti pagal pavadinimą ar vietą...',
    allRegions: 'Visi regionai',
    allTypes: 'Visi tipai',
    villa: 'Vila',
    apartment: 'Butas',
    clearFilters: 'Išvalyti filtrus',
    whyInvest: 'Kodėl investuoti į',
    showing: 'Rodoma',
    casesCount: 'objektų',
    noResults: 'Nerasta objektų, atitinkančių jūsų kriterijus.',
    clearAllFilters: 'Išvalyti visus filtrus'
  },
  
  // FAQ page
  faq: {
    title: 'Dažnai užduodami klausimai',
    subtitle: 'Raskite atsakymus į dažniausiai užduodamus klausimus apie investavimą su Fundora',
    stillHaveQuestions: 'Vis dar turite klausimų?',
    stillHaveQuestionsDesc: 'Mūsų komanda pasiruošusi padėti. Užsisakykite konsultaciją ir atsakysime į visus jūsų klausimus.',
    contactUs: 'Susisiekti',
    questions: {
      q1: 'Kas yra Fundora?',
      a1: 'Fundora yra tarptautinis nekilnojamojo turto investicijų tarpininkas, jungiantis investuotojus su aukštos kokybės nekilnojamojo turto galimybėmis Europoje ir Azijoje. Esame registruoti Lietuvoje (ES) nuo 1998 m.',
      q2: 'Ar galiu investuoti į nekilnojamąjį turtą užsienyje?',
      a2: 'Taip! Mes specializuojamės padėdami tarptautiniams investuotojams įsigyti nekilnojamąjį turtą Šiaurės Kipre, Indonezijoje, Vietname ir Maldyvuose. Mūsų komanda tvarko visus tarpvalstybinių sandorių sudėtingumus.',
      q3: 'Ar galiu nusipirkti nekilnojamąjį turtą nuotoliniu būdu?',
      a3: 'Žinoma. Mes palengviname nuotolinius pirkimus su išsamiomis virtualių turų apžvalgomis, teisine pagalba ir saugiais mokėjimo procesais. Daugelis mūsų klientų sėkmingai investuoja neaplankę turto asmeniškai.',
      q4: 'Kuo Fundora skiriasi nuo kitų?',
      a4: 'Mes sujungiame daugiau nei 10 metų tarptautinių investicijų patirtį su kruopščiai patikrintu partnerių tinklu. Mes pateikiame tik tuos objektus, kuriais tikime, ir užtikriname, kad visi mokėjimai eitų tiesiogiai vystytojams maksimaliam saugumui.',
      q5: 'Kaip galiu pasitikėti Fundora?',
      a5: 'Pasitikėjimas yra mūsų pagrindas. Visi mokėjimai atliekami tiesiogiai nekilnojamojo turto vystytojams, niekada ne per tarpininkus. Mes užtikriname visišką skaidrumą, teisinę pagalbą ir turime įrodytą sėkmę nuo 1998 m.',
      q6: 'Ar jūs valdote nekilnojamąjį turtą?',
      a6: 'Taip, mes bendradarbiaujame su patikimomis vietinėmis turto valdymo įmonėmis, kurios tvarko priežiūrą, nuomą ir nuolatinę jūsų investicijos priežiūrą.',
      q7: 'Ar Fundora tik dideliems investuotojams?',
      a7: 'Visai ne. Mes dirbame su visų dydžių investuotojais – nuo pirmą kartą perkančių iki patyrusių portfelio valdytojų. Mūsų misija – padaryti pasaulines nekilnojamojo turto investicijas prieinamas visiems.'
    }
  },
  
  // Contact page
  contact: {
    title: 'Užsisakyti konsultaciją',
    subtitle: 'Aptarkime jūsų investavimo tikslus ir raskime jums tobulą nekilnojamąjį turtą',
    getInTouch: 'Susisiekite su mumis',
    fullName: 'Vardas ir pavardė',
    fullNamePlaceholder: 'Jonas Jonaitis',
    email: 'El. pašto adresas',
    emailPlaceholder: 'jonas@pavyzdys.lt',
    phone: 'Telefono numeris',
    phonePlaceholder: '+370 600 12345',
    interestedRegion: 'Dominantis regionas',
    selectRegion: 'Pasirinkite regioną',
    northernCyprus: 'Šiaurės Kipras',
    indonesia: 'Indonezija',
    vietnam: 'Vietnamas',
    maldives: 'Maldyvai',
    multipleRegions: 'Keli regionai',
    upcomingTitle: 'Artimiausios konsultacijos',
    nextConsultation: 'Kita konsultacija',
    upcomingSubtitle: 'Rezervuokite vietą artimiausiose nuotolinėse investicijų konsultacijose',
    onlineConsultation: 'Nuotolinė investicijų konsultacija',
    reserve: 'Rezervuoti',
    indonesiaFull: 'Balis, Indonezija',
    pickDate: 'Pasirinkite konsultacijos datą',
    pickDateDesc: 'Galimos nuotolinės konsultacijos šiam regionui',
    consultationDate: 'Konsultacijos data',
    selectDate: 'Pasirinkite datą',
    changeDate: 'Keisti',
    noDates: 'Datų dar nesuplanuota — susisieksime ir suderinsime laiką',
    continueAnyway: 'Tęsti',
    regTitle: 'Rezervuokite vietą',
    regSubtitle: 'Keli duomenys ir jūsų vieta patvirtinta',
    regDetails: 'Konsultacijos informacija',
    regConsultationId: 'Konsultacijos ID',
    regFormat: 'Formatas',
    regFormatValue: 'Nuotoliniu būdu per „Google Meet“',
    regTimeNote: 'Vilniaus laiku (EET/EEST)',
    regName: 'Vardas ir pavardė',
    regEmail: 'El. pašto adresas',
    regPhone: 'Telefono numeris',
    regCountry: 'Gyvenamoji šalis',
    regCountryPlaceholder: 'Lietuva',
    regConfirm: 'Patvirtinti registraciją',
    regSubmitting: 'Tvirtinama...',
    regPrivacy: 'Jūsų duomenis naudojame tik šiai konsultacijai patvirtinti. Jokio šlamšto.',
    regThanksTitle: 'Registracija patvirtinta',
    regThanksBody: 'Dėkojame, kad užsiregistravote į {{region}} investavimo konsultaciją.',
    regThanksEmail: 'Prisijungimo informacija ir „Google Meet“ nuoroda išsiųsti į jūsų el. paštą. Patikrinkite savo el. pašto dėžutę. Jei per kelias minutes laiško nematysite, patikrinkite šlamšto arba reklamų aplanką.',
    regThanksClosing: 'Laukiame susitikimo su jumis.',
    regBackHome: 'Grįžti į pradžią',
    regBrowse: 'Naršyti objektus',
    regUnavailable: 'Ši konsultacija nebegalima',
    regUnavailableDesc: 'Data galbūt jau įvykusi. Pažiūrėkite artimiausias konsultacijas.',
    regSeeUpcoming: 'Artimiausios konsultacijos',
    regError: 'Registracija nepavyko. Patikrinkite duomenis ir bandykite dar kartą.',
    message: 'Žinutė',
    messagePlaceholder: 'Papasakokite apie savo investavimo tikslus ir pageidavimus...',
    sendMessage: 'Siųsti žinutę',
    sending: 'Siunčiama...',
    contactInfo: 'Kontaktinė informacija',
    contactInfoDesc: 'Turite klausimų? Susisiekite su mumis bet kuriuo iš šių kanalų, ir mūsų komanda greitai su jumis susisieks.',
    emailLabel: 'El. paštas',
    respondTime: 'Atsakysime per 24 valandas',
    phoneLabel: 'Telefonas',
    phoneHours: 'Pr-Pn, 9:00 - 18:00',
    office: 'Biuras',
    messageSent: 'Žinutė išsiųsta!',
    messageSentDesc: 'Dėkojame už jūsų susidomėjimą. Susisieksime su jumis per 24 valandas.',
    error: 'Klaida',
    errorMessage: 'Nepavyko išsiųsti žinutės. Bandykite dar kartą.'
  },
  
  // Privacy Policy page
  privacy: {
    title: 'Privatumo politika',
    subtitle: 'Fundora Real Estate - Privatumo politika duomenų rinkimui',
    effectiveDate: 'Įsigaliojimo data: 2025 m. liepos 11 d.',
    intro: 'Fundora Real Estate („mes" arba „mūsų") gerbia jūsų privatumą ir yra įsipareigojusi saugoti jūsų asmeninę informaciją. Ši privatumo politika paaiškina, kaip mes renkame, naudojame, saugome ir apsaugome informaciją, kurią pateikiate atsakydami į mūsų skelbimus arba pateikdami savo duomenis per Facebook ar Instagram potencialių klientų formas.',
    section1Title: '1. Kokią informaciją renkame',
    section1Text: 'Kai sąveikaujate su mūsų reklamos kampanija ir savanoriškai užpildote formą, galime rinkti šią asmeninę informaciją:',
    section1List: ['Vardas ir pavardė', 'El. pašto adresas', 'Telefono numeris'],
    section1Footer: 'Šiuos duomenis renkame tik žemiau nurodytiems tikslams ir tik su jūsų sutikimu.',
    section2Title: '2. Kaip naudojame jūsų informaciją',
    section2Text: 'Jūsų asmeninius duomenis naudojame šiais tikslais:',
    section2List: [
      'Susisiekti su jumis dėl nekilnojamojo turto investavimo galimybių, kurios gali jus dominti',
      'Teikti asmeninę informaciją ir naujienas apie mūsų paslaugas',
      'Atsakyti į jūsų užklausas ar prašymus',
      'Laikytis bet kokių teisinių įsipareigojimų'
    ],
    section2Footer: 'Jūsų informacija nebus parduota, nuomojama ar dalijamasi su trečiosiomis šalimis jų rinkodaros tikslais.',
    section3Title: '3. Teisinis duomenų tvarkymo pagrindas',
    section3Text: 'Mūsų jūsų asmeninių duomenų tvarkymas grindžiamas jūsų aiškiu sutikimu, kurį pateikiate pateikdami savo duomenis per potencialių klientų formą. Galite bet kada atšaukti savo sutikimą susisiekę su mumis (žr. 6 skyrių).',
    section4Title: '4. Duomenų saugojimas',
    section4Text: 'Jūsų asmeninius duomenis saugosime tik tiek laiko, kiek būtina šioje politikoje nurodytiems tikslams įgyvendinti arba kiek to reikalauja taikomi įstatymai. Jei atšauksite savo sutikimą, jūsų informacija bus nedelsiant ištrinta arba anonimizuota.',
    section5Title: '5. Duomenų saugumas',
    section5Text: 'Įgyvendiname tinkamas technines ir organizacines priemones, kad apsaugotume jūsų asmeninius duomenis nuo neteisėtos prieigos, atskleidimo, pakeitimo ar sunaikinimo. Prieiga prie jūsų duomenų suteikiama tik įgaliotiems darbuotojams.',
    section6Title: '6. Jūsų teisės',
    section6Text: 'Jūs turite teisę:',
    section6List: [
      'Susipažinti su mūsų turimais jūsų asmeniniais duomenimis',
      'Prašyti ištaisyti netikslius duomenis',
      'Prašyti ištrinti jūsų duomenis',
      'Bet kada atšaukti savo sutikimą',
      'Pateikti skundą duomenų apsaugos institucijai, jei manote, kad jūsų teisės buvo pažeistos'
    ],
    section6Footer: 'Norėdami pasinaudoti bet kuria iš šių teisių, susisiekite su mumis:',
    section7Title: '7. Trečiųjų šalių platformos',
    section7Text: 'Ši privatumo politika taikoma tik duomenims, surinktiems per Facebook ir Instagram potencialių klientų formas. Atkreipkite dėmesį, kad Facebook ir Instagram priklauso Meta Platforms, Inc., ir jūsų naudojimuisi šiomis platformomis taip pat taikoma Meta duomenų politika, pasiekiama adresu:',
    section7Footer: 'Mes neprisiimame atsakomybės už Meta duomenų tvarkymo praktiką, tačiau užtikriname, kad mūsų jūsų duomenų naudojimas atitinka jų platformos politiką.',
    section8Title: '8. Šios politikos atnaujinimai',
    section8Text: 'Šią privatumo politiką galime retkarčiais atnaujinti. Bet kokie pakeitimai bus paskelbti čia su atnaujinta „Įsigaliojimo data". Raginame periodiškai peržiūrėti šią politiką.',
    section8Footer: 'Jei turite klausimų ar abejonių dėl šios privatumo politikos, susisiekite su mumis aukščiau nurodytu el. paštu.',
    questionsTitle: 'Klausimai apie mūsų privatumo politiką?',
    questionsText: 'Jei turite klausimų ar abejonių, nedvejodami susisiekite su mumis.'
  },
  
  // Newsletter component
  newsletter: {
    title: 'Gaukite naujausias galimybes',
    subtitle: 'Prenumeruokite ir gaukite išskirtinius nekilnojamojo turto pasiūlymus, rinkos įžvalgas ir investavimo patarimus tiesiai į savo el. paštą.',
    placeholder: 'Įveskite savo el. paštą',
    subscribe: 'Prenumeruoti',
    subscribing: 'Prenumeruojama...',
    subscribed: 'Užprenumeruota!',
    subscribedDesc: 'Dėkojame, kad užsiprenumeravote mūsų naujienlaiškį.',
    error: 'Klaida',
    errorMessage: 'Nepavyko užprenumeruoti. Bandykite dar kartą.'
  },
  
  // Footer
  footer: {
    description: 'Jungiame investuotojus su aukščiausios kokybės nekilnojamojo turto galimybėmis Europoje ir Azijoje nuo 1998 m.',
    quickLinks: 'Greitos nuorodos',
    ourRegions: 'Mūsų regionai',
    contact: 'Kontaktai',
    copyright: '© {{year}} Fundora. Visos teisės saugomos.'
  },
  
  // Property Card
  property: {
    featured: 'Rekomenduojama',
    apartments: 'Butai',
    villas: 'Vilos',
    beds: 'Miegamieji',
    baths: 'Vonios',
    from: 'Nuo',
    villa: 'Vila',
    apartment: 'Butas',
    mixed: 'Mišrus',
    studio: 'Studija',
    terrace: 'terasa',
    balcony: 'balkonas'
  },
  
  // Property Descriptions
  properties: {
    1: {
      description: 'Tai modernus kompleksas su „VISKAS VIENOJE" koncepcija, kur viskas, ko jums reikia, surinkta vienoje vietoje. „Viskas vienoje" koncepcija leidžia mėgautis restoranais, apsipirkimu, veiklomis ir pramogomis neišeinant iš komplekso!'
    },
    2: {
      description: 'Gerai išvystyta komplekso infrastruktūra sukuria patogias gyvenimo ir poilsio sąlygas, didindama nekilnojamojo turto patrauklumą tiek gyvenimui, tiek investicijoms.'
    },
    3: {
      description: 'Ugnikalniai yra viena ryškiausių Balio kraštovaizdžio savybių, apipinta daugybe mitų ir legendų, kurios vis dar pritraukia šimtus tūkstančių turistų iš viso pasaulio patirti kalnų dvasią. Šiame projekte dėmesys skiriamas vulkaninei uolienai ir daugiasluoksniam apšvietimui, atspindinčiam įspūdingą ir dinamišką išsiveržiančio ugnikalnio prigimtį.'
    },
    4: {
      description: 'Butai – didelė paklausa tiek gyvenimui, tiek nuomai. Vos 300 m arba 3 minučių pėsčiomis iki populiarių Finns ir Atlas paplūdimių bei klubų. Berawa – labiausiai pageidaujama Balio vietovė su dideliu turistų srautu. Didelis kompleksas su infrastruktūra ir stogo terasa su panoraminiais vaizdais. Didelis likvidumas ir stabilus kainų augimas.'
    },
    6: {
      description: 'Aukščiausios klasės viešbučių kompleksas, esantis pirmoje vandenyno linijoje, apsuptas lagūnų su krištolo skaidrumo vandeniu. Kiekvienas butas siūlo vaizdingas panoramas su tiesioginiu vaizdu į vandenyną ir saulėlydžius.'
    },
    7: {
      description: 'Pajūrio miesto rajonas gyvo miesto viduryje. Tai antrieji namai milijonams vietnamiečių, mylinčių jūrą. Tvirtas 44 ha miestas, stovintis aukštai, apglėbiantis Dangiškojo rojaus įlanką, žadantis šviesią ateitį šiaurinei kelionei.'
    },
    8: {
      description: 'Tai ne tik nekilnojamasis turtas – tai kruopščiai suprojektuotas gyvenamasis kompleksas, visiškai pritaikytas vietinei kultūrai ir religiniams principams. Toks unikalus sprendimas užtikrina nuolatinę paklausą ir daro šį projektą išskirtine investicine galimybe saloje.'
    },
    9: {
      description: 'Vos 100 metrų nuo paplūdimio, MALIBU siūlo neprilygstamą prieigą prie Viduržemio jūros krantų. Įsikūręs Esentepe, kompleksas derina gamtos grožį su šiuolaikiniais patogumais.'
    },
    12: {
      description: 'Stabilus investicinis projektas su viešbučio valdymu, garantuotu modeliu ir gerai išvystyta infrastruktūra — tinka tiek pajamų generavimui, tiek ilgalaikiam vertės augimui.'
    }
  },
  
  // Property Detail Page
  propertyDetail: {
    backToCases: 'Grįžti į objektus',
    price: 'Kaina',
    keyDetails: 'Pagrindinė informacija',
    location: 'Vieta',
    propertyType: 'Turto tipas',
    address: 'Adresas',
    description: 'Apie šį objektą',
    interested: 'Domina šis objektas?',
    getAdvice: 'Gaukite asmeninę konsultaciją ir sužinokite, kaip šis objektas atitinka jūsų investavimo tikslus.',
    directPayments: 'Tiesioginiai mokėjimai vystytojams',
    legalSupport: 'Visapusiška teisinė pagalba',
    remoteAvailable: 'Galimybė pirkti nuotoliniu būdu',
    browseMore: 'Peržiūrėti visus objektus',
    notFound: 'Objektas nerastas'
  },
  
  // Regions
  regions: {
    northernCyprus: {
      name: 'Šiaurės Kipras',
      description: 'Modernūs butai ir studijos su investavimo galimybėmis',
      count: '3 objektai',
      investmentInfo: 'Šiaurės Kipras sujungia nuostabias Viduržemio jūros pakrantes su nepaliesta gamtos grožiu kainomis, žymiai mažesnėmis nei Pietų Kipre ir Vakarų Europoje. Augantis turizmo sektorius ir didėjantis tarptautinis pripažinimas sukuria stiprų kapitalo augimo potencialą. Su gražiais paplūdimiais, kalnų kraštovaizdžiais ir nesudėtingu pirkimo procesu užsieniečiams, tai vis populiaresnis pasirinkimas investuotojams, ieškantiems prieinamos Viduržemio jūros prabangos.'
    },
    bali: {
      name: 'Balis (Indonezija)',
      description: 'Tropinio rojaus vilos ir butai Balyje',
      count: '4 objektai',
      investmentInfo: 'Balio nekilnojamojo turto rinka siūlo išskirtinius grąžos rodiklius, skatinamus ištisus metus trunkančio turizmo ir klestinčios skaitmeninių klajoklių bendruomenės. Salos unikali kultūra, prieinamos gyvenimo išlaidos ir tropinis klimatas kasmet pritraukia milijonus lankytojų, užtikrinant nuoseklią nuomos paklausą. Indonezijos nekilnojamojo turto įstatymai teikia pirmenybę ilgalaikėms nuomos sutartims, kurios užtikrina saugumą, kartu išlaikant prieinamą įėjimo kainą tarptautiniams investuotojams.'
    },
    vietnam: {
      name: 'Vietnamas',
      description: 'Modernūs butai ir prabangūs projektai',
      count: '1 objektas',
      investmentInfo: 'Sparčiai auganti Vietnamo ekonomika ir besiformuojanti vidurinioji klasė sukuria stiprią kokybiško būsto paklausą. Pakrantės miestai, tokie kaip Nha Trangas, siūlo paplūdimio nekilnojamąjį turtą patraukliomis kainomis su reikšmingu augimo potencialu. Šalies politinis stabilumas, gerėjanti infrastruktūra ir didėjančios užsienio investicijos daro ją viena perspektyviausių Pietryčių Azijos nekilnojamojo turto rinkų.'
    },
    maldives: {
      name: 'Maldyvai',
      description: 'Aukščiausios prabangos salų nekilnojamasis turtas ir kurortų investicijos',
      count: '1 objektas',
      investmentInfo: 'Maldyvai atstovauja prabangaus tropinio nekilnojamojo turto viršūnę su išskirtiniais kurortų objektais ir vandenyno pakrantės projektais. Kaip viena iš svarbiausių pasaulio turistinių krypčių, čia esantis nekilnojamasis turtas naudojasi itin turtingų klientų ir išskirtinėmis nuomos pajamomis. Vyriausybės dėmesys tvariam turizmui ir ribotos plėtros galimybės užtikrina išskirtinumą ir ilgalaikį vertės augimą.'
    }
  }
};

// Russian translations
const ruTranslations = {
  // Navigation
  nav: {
    home: 'Главная',
    cases: 'Объекты',
    about: 'О нас',
    faq: 'FAQ',
    bookConsultation: 'Записаться на консультацию'
  },
  
  // Home page
  home: {
    heroTitle1: 'Надёжные инвестиции в зарубежную',
    heroTitle2: 'недвижимость',
    heroSubtitle: 'Связываем вас с премиальными возможностями недвижимости в Европе и Азии.',
    exploreCases: 'Смотреть объекты',
    whyChoose: 'Почему Fundora',
    whyChooseSubtitle: 'Ваш надёжный партнёр в глобальных инвестициях в недвижимость',
    trustExperience: 'Доверие и опыт',
    trustExperienceDesc: 'Более 10 лет международного инвестиционного опыта с проверенной репутацией с 1998 года. Все платежи идут напрямую застройщикам для максимальной безопасности.',
    globalReach: 'Глобальный охват',
    globalReachDesc: 'Эксклюзивный доступ к премиальной недвижимости в Северном Кипре, Индонезии, Вьетнаме и на Мальдивах с местной экспертизой.',
    sustainableGrowth: 'Устойчивый рост',
    sustainableGrowthDesc: 'Стратегические инвестиционные возможности, разработанные для долгосрочного роста стоимости и диверсификации портфеля.',
    featuredCases: 'Рекомендуемые объекты',
    featuredCasesSubtitle: 'Отобранные инвестиционные возможности из нашего глобального портфеля',
    viewAll: 'Смотреть все',
    viewAllCases: 'Смотреть все объекты',
    investmentRegions: 'Регионы инвестиций',
    investmentRegionsSubtitle: 'Откройте возможности в самых востребованных направлениях мира',
    readyToInvest: 'Готовы инвестировать глобально?',
    readyToInvestDesc: 'Получите персональную консультацию и откройте лучшие международные возможности недвижимости, адаптированные под ваши инвестиционные цели.',
    bookAConsultation: 'Записаться на консультацию'
  },
  
  // About page
  about: {
    title: 'О Fundora',
    subtitle: 'Ваш надёжный партнёр в глобальных инвестициях в недвижимость с 1998 года',
    ourMission: 'Наша миссия',
    missionText1: 'Fundora — международный бренд-посредник в сфере инвестиций в недвижимость, который связывает инвесторов с высококачественными объектами недвижимости по всему миру.',
    missionText2: 'Наша миссия — помочь клиентам достичь устойчивого роста стоимости через умные инвестиции в недвижимость на тщательно отобранных рынках Европы и Азии.',
    missionText3: 'Зарегистрированные в Литве (ЕС) с 1998 года, мы привносим более двух десятилетий экспертизы, честности и приверженности совершенству в каждую сделку.',
    coreValues: 'Наши ценности',
    coreValuesSubtitle: 'Принципы, которыми мы руководствуемся при принятии каждого решения',
    reliability: 'Надёжность',
    reliabilityDesc: 'Доверие и прозрачность в каждой сделке. Все платежи идут напрямую застройщикам.',
    globalReachValue: 'Глобальный охват',
    globalReachValueDesc: 'Доступ к премиальной недвижимости в Европе и Азии с местной экспертизой.',
    growth: 'Рост',
    growthDesc: 'Стратегические инвестиции, разработанные для долгосрочного роста стоимости.',
    clientFocused: 'Ориентация на клиента',
    clientFocusedDesc: 'Персональный сервис, адаптированный под ваши уникальные инвестиционные цели.',
    ourApproach: 'Наш подход',
    expertVerification: 'Экспертная проверка',
    expertVerificationDesc: 'Каждый объект в нашем портфеле лично проверен нашей опытной командой. Мы представляем только те возможности, в которые инвестировали бы сами.',
    directPartnerships: 'Прямые партнёрства',
    directPartnershipsDesc: 'Мы работаем напрямую с надёжными застройщиками и владельцами недвижимости, обеспечивая вам лучшие цены и условия без лишних посредников.',
    endToEndSupport: 'Полная поддержка',
    endToEndSupportDesc: 'От первичной консультации до управления недвижимостью — мы обеспечиваем комплексную поддержку на протяжении всего вашего инвестиционного пути.',
    investWithConfidence: 'Инвестируйте с уверенностью',
    investWithConfidenceDesc: 'Присоединяйтесь к нам в поиске исключительных инвестиционных возможностей в недвижимость. Как активные инвесторы, мы представляем только те объекты, в которые верим и в которые инвестировали бы сами.'
  },
  
  // Cases/Properties page
  cases: {
    title: 'Инвестиционные объекты',
    subtitle: 'Просмотрите нашу подборку премиальной недвижимости в Европе и Азии',
    searchPlaceholder: 'Поиск по названию или местоположению...',
    allRegions: 'Все регионы',
    allTypes: 'Все типы',
    villa: 'Вилла',
    apartment: 'Апартаменты',
    clearFilters: 'Сбросить фильтры',
    whyInvest: 'Почему инвестировать в',
    showing: 'Показано',
    casesCount: 'объектов',
    noResults: 'Объекты по вашим критериям не найдены.',
    clearAllFilters: 'Сбросить все фильтры'
  },
  
  // FAQ page
  faq: {
    title: 'Часто задаваемые вопросы',
    subtitle: 'Найдите ответы на распространённые вопросы об инвестировании с Fundora',
    stillHaveQuestions: 'Остались вопросы?',
    stillHaveQuestionsDesc: 'Наша команда готова помочь. Запишитесь на консультацию, и мы ответим на все ваши вопросы.',
    contactUs: 'Связаться с нами',
    questions: {
      q1: 'Что такое Fundora?',
      a1: 'Fundora — международный бренд-посредник в сфере инвестиций в недвижимость, связывающий инвесторов с высококачественными объектами в Европе и Азии. Мы зарегистрированы в Литве (ЕС) с 1998 года.',
      q2: 'Могу ли я инвестировать в недвижимость за рубежом?',
      a2: 'Да! Мы специализируемся на помощи международным инвесторам в приобретении недвижимости в Северном Кипре, Индонезии, Вьетнаме и на Мальдивах. Наша команда берёт на себя все сложности трансграничных сделок.',
      q3: 'Могу ли я купить недвижимость удалённо?',
      a3: 'Безусловно. Мы обеспечиваем удалённые покупки с помощью комплексных виртуальных туров, юридической поддержки и безопасных платёжных процессов. Многие наши клиенты успешно инвестируют без личного посещения объекта.',
      q4: 'Чем Fundora отличается от других?',
      a4: 'Мы сочетаем более 10 лет международного инвестиционного опыта с тщательно проверенной сетью партнёров. Мы представляем только те объекты, в которые верим, и гарантируем, что все платежи идут напрямую застройщикам для максимальной безопасности.',
      q5: 'Как я могу доверять Fundora?',
      a5: 'Доверие — наш фундамент. Все платежи идут напрямую застройщикам недвижимости, никогда через посредников. Мы обеспечиваем полную прозрачность, юридическую поддержку и имеем проверенную репутацию с 1998 года.',
      q6: 'Вы управляете недвижимостью?',
      a6: 'Да, мы сотрудничаем с надёжными местными управляющими компаниями для обслуживания, аренды и постоянного ухода за вашими инвестициями.',
      q7: 'Fundora только для крупных инвесторов?',
      a7: 'Вовсе нет. Мы работаем с инвесторами любого масштаба — от начинающих покупателей до опытных управляющих портфелями. Наша миссия — сделать глобальные инвестиции в недвижимость доступными для всех.'
    }
  },
  
  // Contact page
  contact: {
    title: 'Записаться на консультацию',
    subtitle: 'Давайте обсудим ваши инвестиционные цели и найдём идеальную недвижимость для вас',
    getInTouch: 'Свяжитесь с нами',
    fullName: 'Полное имя',
    fullNamePlaceholder: 'Иван Иванов',
    email: 'Электронная почта',
    emailPlaceholder: 'ivan@example.com',
    phone: 'Номер телефона',
    phonePlaceholder: '+7 999 123 4567',
    interestedRegion: 'Интересующий регион',
    selectRegion: 'Выберите регион',
    northernCyprus: 'Северный Кипр',
    indonesia: 'Индонезия',
    vietnam: 'Вьетнам',
    maldives: 'Мальдивы',
    multipleRegions: 'Несколько регионов',
    upcomingTitle: 'Ближайшие консультации',
    nextConsultation: 'Следующая консультация',
    upcomingSubtitle: 'Забронируйте место на одной из ближайших онлайн-консультаций по инвестициям',
    onlineConsultation: 'Онлайн-консультация по инвестициям',
    reserve: 'Забронировать',
    indonesiaFull: 'Бали, Индонезия',
    pickDate: 'Выберите дату консультации',
    pickDateDesc: 'Доступные онлайн-консультации для этого региона',
    consultationDate: 'Дата консультации',
    selectDate: 'Выберите дату',
    changeDate: 'Изменить',
    noDates: 'Даты пока не назначены — мы свяжемся с вами и согласуем время',
    continueAnyway: 'Продолжить',
    regTitle: 'Забронируйте место',
    regSubtitle: 'Несколько данных — и ваше место подтверждено',
    regDetails: 'Информация о консультации',
    regConsultationId: 'ID консультации',
    regFormat: 'Формат',
    regFormatValue: 'Онлайн через Google Meet',
    regTimeNote: 'по вильнюсскому времени (EET/EEST)',
    regName: 'Имя и фамилия',
    regEmail: 'Адрес эл. почты',
    regPhone: 'Номер телефона',
    regCountry: 'Страна проживания',
    regCountryPlaceholder: 'Литва',
    regConfirm: 'Подтвердить регистрацию',
    regSubmitting: 'Подтверждаем...',
    regPrivacy: 'Мы используем ваши данные только для подтверждения этой консультации. Никакого спама.',
    regThanksTitle: 'Регистрация подтверждена',
    regThanksBody: 'Благодарим за регистрацию на инвестиционную консультацию: {{region}}.',
    regThanksEmail: 'Информация для подключения и ссылка на Google Meet отправлены на вашу электронную почту. Проверьте почтовый ящик. Если письма нет в течение нескольких минут, проверьте папку «Спам» или «Рассылки».',
    regThanksClosing: 'Ждём встречи с вами.',
    regBackHome: 'На главную',
    regBrowse: 'Смотреть объекты',
    regUnavailable: 'Эта консультация больше недоступна',
    regUnavailableDesc: 'Возможно, дата уже прошла. Посмотрите ближайшие консультации.',
    regSeeUpcoming: 'Ближайшие консультации',
    regError: 'Регистрация не удалась. Проверьте данные и попробуйте снова.',
    message: 'Сообщение',
    messagePlaceholder: 'Расскажите о ваших инвестиционных целях и предпочтениях...',
    sendMessage: 'Отправить сообщение',
    sending: 'Отправка...',
    contactInfo: 'Контактная информация',
    contactInfoDesc: 'Есть вопросы? Свяжитесь с нами любым удобным способом, и наша команда оперативно ответит вам.',
    emailLabel: 'Email',
    respondTime: 'Ответим в течение 24 часов',
    phoneLabel: 'Телефон',
    phoneHours: 'Пн-Пт, 9:00 - 18:00',
    office: 'Офис',
    messageSent: 'Сообщение отправлено!',
    messageSentDesc: 'Благодарим за интерес. Мы свяжемся с вами в течение 24 часов.',
    error: 'Ошибка',
    errorMessage: 'Не удалось отправить сообщение. Пожалуйста, попробуйте снова.'
  },
  
  // Privacy Policy page
  privacy: {
    title: 'Политика конфиденциальности',
    subtitle: 'Fundora Real Estate — Политика конфиденциальности для сбора данных',
    effectiveDate: 'Дата вступления в силу: 11 июля 2025 г.',
    intro: 'Fundora Real Estate («мы» или «наш») уважает вашу конфиденциальность и обязуется защищать вашу личную информацию. Эта Политика конфиденциальности объясняет, как мы собираем, используем, храним и защищаем информацию, которую вы предоставляете при ответе на наши рекламные объявления или отправке данных через формы лидов Facebook или Instagram.',
    section1Title: '1. Какую информацию мы собираем',
    section1Text: 'Когда вы взаимодействуете с нашей рекламной кампанией и добровольно заполняете форму, мы можем собирать следующую личную информацию:',
    section1List: ['Полное имя', 'Адрес электронной почты', 'Номер телефона'],
    section1Footer: 'Мы собираем эти данные исключительно для целей, указанных ниже, и только с вашего согласия.',
    section2Title: '2. Как мы используем вашу информацию',
    section2Text: 'Мы используем ваши персональные данные в следующих целях:',
    section2List: [
      'Для связи с вами относительно инвестиционных возможностей в недвижимость, которые могут вас заинтересовать',
      'Для предоставления персонализированной информации и обновлений о наших услугах',
      'Для ответа на ваши запросы или заявки',
      'Для соблюдения любых юридических обязательств'
    ],
    section2Footer: 'Ваша информация не будет продана, сдана в аренду или передана третьим лицам для их маркетинговых целей.',
    section3Title: '3. Правовая основа обработки',
    section3Text: 'Обработка ваших персональных данных основана на вашем явном согласии, которое вы даёте при отправке данных через форму лидов. Вы можете отозвать своё согласие в любое время, связавшись с нами (см. Раздел 6).',
    section4Title: '4. Хранение данных',
    section4Text: 'Мы будем хранить ваши персональные данные только столько, сколько необходимо для достижения целей, указанных в этой политике, или в соответствии с требованиями применимого законодательства. Если вы отзовёте своё согласие, ваша информация будет незамедлительно удалена или анонимизирована.',
    section5Title: '5. Безопасность данных',
    section5Text: 'Мы применяем соответствующие технические и организационные меры для защиты ваших персональных данных от несанкционированного доступа, раскрытия, изменения или уничтожения. Доступ к вашим данным предоставляется только уполномоченному персоналу.',
    section6Title: '6. Ваши права',
    section6Text: 'Вы имеете право:',
    section6List: [
      'Получить доступ к персональным данным, которые мы храним о вас',
      'Запросить исправление неточных данных',
      'Запросить удаление ваших данных',
      'Отозвать своё согласие в любое время',
      'Подать жалобу в орган по защите данных, если вы считаете, что ваши права были нарушены'
    ],
    section6Footer: 'Для реализации любого из этих прав свяжитесь с нами:',
    section7Title: '7. Сторонние платформы',
    section7Text: 'Эта Политика конфиденциальности применяется только к данным, собранным через формы лидов Facebook и Instagram. Обратите внимание, что Facebook и Instagram принадлежат Meta Platforms, Inc., и использование этих платформ также регулируется Политикой данных Meta, доступной по адресу:',
    section7Footer: 'Мы не несём ответственности за практику обработки данных Meta, но гарантируем, что наше использование ваших данных соответствует политикам их платформы.',
    section8Title: '8. Обновления этой политики',
    section8Text: 'Мы можем периодически обновлять эту Политику конфиденциальности. Любые изменения будут опубликованы здесь с обновлённой «Датой вступления в силу». Мы рекомендуем периодически просматривать эту политику.',
    section8Footer: 'Если у вас есть вопросы или сомнения относительно этой Политики конфиденциальности, свяжитесь с нами по указанной выше электронной почте.',
    questionsTitle: 'Вопросы о нашей Политике конфиденциальности?',
    questionsText: 'Если у вас есть вопросы или сомнения, не стесняйтесь связаться с нами.'
  },
  
  // Newsletter component
  newsletter: {
    title: 'Будьте в курсе новых возможностей',
    subtitle: 'Подпишитесь, чтобы получать эксклюзивные предложения недвижимости, аналитику рынка и инвестиционные советы прямо на вашу почту.',
    placeholder: 'Введите ваш email',
    subscribe: 'Подписаться',
    subscribing: 'Подписка...',
    subscribed: 'Подписка оформлена!',
    subscribedDesc: 'Благодарим за подписку на нашу рассылку.',
    error: 'Ошибка',
    errorMessage: 'Не удалось подписаться. Пожалуйста, попробуйте снова.'
  },
  
  // Footer
  footer: {
    description: 'Связываем инвесторов с премиальными возможностями недвижимости в Европе и Азии с 1998 года.',
    quickLinks: 'Быстрые ссылки',
    ourRegions: 'Наши регионы',
    contact: 'Контакты',
    copyright: '© {{year}} Fundora. Все права защищены.'
  },
  
  // Property Card
  property: {
    featured: 'Рекомендуемый',
    apartments: 'Апартаменты',
    villas: 'Виллы',
    beds: 'Спальни',
    baths: 'Ванные',
    from: 'От',
    villa: 'Вилла',
    apartment: 'Апартаменты',
    mixed: 'Смешанный',
    studio: 'Студия',
    terrace: 'терраса',
    balcony: 'балкон'
  },
  
  // Property Descriptions
  properties: {
    1: {
      description: 'Это современный комплекс с концепцией «ВСЁ В ОДНОМ», где всё необходимое собрано в одном месте. Концепция «Всё в одном» позволяет наслаждаться ресторанами, шопингом, развлечениями и активностями, не выходя из комплекса!'
    },
    2: {
      description: 'Развитая инфраструктура комплекса создаёт комфортные условия для проживания и отдыха, повышая привлекательность недвижимости как для проживания, так и для инвестиций.'
    },
    3: {
      description: 'Вулканы — одна из самых ярких особенностей ландшафта Бали, окружённая множеством мифов и легенд, которые до сих пор привлекают сотни тысяч туристов со всего мира, чтобы ощутить дух гор. В этом проекте внимание уделено вулканической породе и многоуровневому освещению, отражающему впечатляющую и динамичную природу извергающегося вулкана.'
    },
    4: {
      description: 'Апартаменты — высокий спрос как для проживания, так и для аренды. Всего 300 м или 3 минуты пешком до популярных пляжей и клубов Finns и Atlas. Берава — самый востребованный район Бали с высоким туристическим потоком. Большой комплекс с инфраструктурой и крышей с панорамными видами. Высокая ликвидность и стабильный рост цен.'
    },
    6: {
      description: 'Элитный гостиничный комплекс на первой линии океана, окружённый лагунами с кристально чистой водой. Каждый номер предлагает живописные виды с прямым видом на океан и закаты.'
    },
    7: {
      description: 'Приморский городской район в центре живого города. Это второй дом для миллионов вьетнамцев, любящих море. Надёжный город площадью 44 га, возвышающийся над заливом Райский Рай, обещающий светлое будущее для северного путешествия.'
    },
    8: {
      description: 'Это не просто недвижимость — это тщательно спроектированный жилой комплекс, полностью адаптированный к местной культуре и религиозным принципам. Такое уникальное решение обеспечивает постоянный спрос и делает этот проект исключительной инвестиционной возможностью на острове.'
    },
    9: {
      description: 'Всего в 100 метрах от пляжа MALIBU предлагает непревзойдённый доступ к берегам Средиземного моря. Расположенный в Эсентепе, комплекс сочетает природную красоту с современным комфортом.'
    },
    12: {
      description: 'Стабильный инвестиционный проект с гостиничным управлением, гарантированной моделью и развитой инфраструктурой — подходит как для генерации дохода, так и для долгосрочного роста стоимости.'
    }
  },
  
  // Property Detail Page
  propertyDetail: {
    backToCases: 'Назад к объектам',
    price: 'Цена',
    keyDetails: 'Основная информация',
    location: 'Расположение',
    propertyType: 'Тип недвижимости',
    address: 'Адрес',
    description: 'Об этом объекте',
    interested: 'Заинтересовал этот объект?',
    getAdvice: 'Получите персональную консультацию и узнайте, как этот объект соответствует вашим инвестиционным целям.',
    directPayments: 'Прямые платежи застройщикам',
    legalSupport: 'Полная юридическая поддержка',
    remoteAvailable: 'Возможность удалённой покупки',
    browseMore: 'Смотреть все объекты',
    notFound: 'Объект не найден'
  },
  
  // Regions
  regions: {
    northernCyprus: {
      name: 'Северный Кипр',
      nameAccusative: 'Северный Кипр',
      description: 'Современные апартаменты и студии с инвестиционными возможностями',
      count: '3 объекта',
      investmentInfo: 'Северный Кипр сочетает потрясающее побережье Средиземного моря с нетронутой природной красотой по ценам значительно ниже, чем на Южном Кипре и в Западной Европе. Растущий туристический сектор и возрастающее международное признание создают сильный потенциал для роста капитала. С красивыми пляжами, горными пейзажами и простым процессом покупки для иностранцев это всё более популярный выбор для инвесторов, ищущих доступную средиземноморскую роскошь.'
    },
    bali: {
      name: 'Бали (Индонезия)',
      nameAccusative: 'Бали (Индонезию)',
      description: 'Виллы и апартаменты тропического рая на Бали',
      count: '4 объекта',
      investmentInfo: 'Рынок недвижимости Бали предлагает исключительную доходность благодаря круглогодичному туризму и процветающему сообществу цифровых кочевников. Уникальная культура острова, доступная стоимость жизни и тропический климат ежегодно привлекают миллионы посетителей, обеспечивая стабильный спрос на аренду. Законы о недвижимости Индонезии отдают предпочтение долгосрочной аренде, которая обеспечивает безопасность при сохранении доступной цены входа для международных инвесторов.'
    },
    vietnam: {
      name: 'Вьетнам',
      nameAccusative: 'Вьетнам',
      description: 'Современные апартаменты и элитные проекты',
      count: '1 объект',
      investmentInfo: 'Быстрорастущая экономика Вьетнама и формирующийся средний класс создают высокий спрос на качественное жильё. Прибрежные города, такие как Нячанг, предлагают недвижимость на первой линии по привлекательным ценам со значительным потенциалом роста. Политическая стабильность страны, улучшающаяся инфраструктура и растущие иностранные инвестиции делают её одним из самых перспективных рынков недвижимости Юго-Восточной Азии.'
    },
    maldives: {
      name: 'Мальдивы',
      nameAccusative: 'Мальдивы',
      description: 'Ультралюксовая островная недвижимость и курортные инвестиции',
      count: '1 объект',
      investmentInfo: 'Мальдивы представляют вершину роскошной тропической недвижимости с эксклюзивными курортными объектами и проектами на берегу океана. Как одно из главных туристических направлений мира, недвижимость здесь пользуется спросом у ультрасостоятельных клиентов и обеспечивает исключительную арендную доходность. Фокус правительства на устойчивом туризме и ограниченные возможности застройки гарантируют эксклюзивность и долгосрочный рост стоимости.'
    }
  }
};

// Polish translations
const plTranslations = {
  // Navigation
  nav: {
    home: 'Strona główna',
    cases: 'Obiekty',
    about: 'O nas',
    faq: 'FAQ',
    bookConsultation: 'Umów konsultację'
  },
  
  // Home page
  home: {
    heroTitle1: 'Zaufane inwestycje w zagraniczną',
    heroTitle2: 'nieruchomość',
    heroSubtitle: 'Łączymy Cię z najlepszymi możliwościami inwestycyjnymi w nieruchomości w Europie i Azji.',
    exploreCases: 'Zobacz obiekty',
    whyChoose: 'Dlaczego Fundora',
    whyChooseSubtitle: 'Twój zaufany partner w globalnych inwestycjach w nieruchomości',
    trustExperience: 'Zaufanie i doświadczenie',
    trustExperienceDesc: 'Ponad 10 lat międzynarodowego doświadczenia inwestycyjnego z udokumentowaną historią od 1998 roku. Wszystkie płatności trafiają bezpośrednio do deweloperów dla maksymalnego bezpieczeństwa.',
    globalReach: 'Globalny zasięg',
    globalReachDesc: 'Ekskluzywny dostęp do premium nieruchomości w na Cyprze Północnym, w Indonezji, Wietnamie i na Malediwach z lokalną ekspertyzą.',
    sustainableGrowth: 'Zrównoważony wzrost',
    sustainableGrowthDesc: 'Strategiczne możliwości inwestycyjne zaprojektowane dla długoterminowego wzrostu wartości i dywersyfikacji portfela.',
    featuredCases: 'Polecane obiekty',
    featuredCasesSubtitle: 'Wyselekcjonowane możliwości inwestycyjne z naszego globalnego portfela',
    viewAll: 'Zobacz wszystkie',
    viewAllCases: 'Zobacz wszystkie obiekty',
    investmentRegions: 'Regiony inwestycyjne',
    investmentRegionsSubtitle: 'Odkryj możliwości w najbardziej pożądanych destynacjach świata',
    readyToInvest: 'Gotowy do globalnych inwestycji?',
    readyToInvestDesc: 'Uzyskaj spersonalizowaną poradę i odkryj najlepsze międzynarodowe możliwości nieruchomości dostosowane do Twoich celów inwestycyjnych.',
    bookAConsultation: 'Umów konsultację'
  },
  
  // About page
  about: {
    title: 'O Fundora',
    subtitle: 'Twój zaufany partner w globalnych inwestycjach w nieruchomości od 1998 roku',
    ourMission: 'Nasza misja',
    missionText1: 'Fundora to międzynarodowa marka pośrednicząca w inwestycjach w nieruchomości, która łączy inwestorów z wysokiej jakości obiektami na całym świecie.',
    missionText2: 'Naszą misją jest pomoc klientom w osiągnięciu zrównoważonego wzrostu wartości poprzez mądre inwestycje w nieruchomości na starannie wybranych rynkach Europy i Azji.',
    missionText3: 'Zarejestrowani na Litwie (UE) od 1998 roku, wnosimy ponad dwie dekady ekspertyzy, uczciwości i zaangażowania w doskonałość w każdej transakcji.',
    coreValues: 'Nasze wartości',
    coreValuesSubtitle: 'Zasady, którymi kierujemy się przy każdej decyzji',
    reliability: 'Niezawodność',
    reliabilityDesc: 'Zaufanie i przejrzystość w każdej transakcji. Wszystkie płatności trafiają bezpośrednio do deweloperów.',
    globalReachValue: 'Globalny zasięg',
    globalReachValueDesc: 'Dostęp do premium nieruchomości w Europie i Azji z lokalną ekspertyzą.',
    growth: 'Wzrost',
    growthDesc: 'Strategiczne inwestycje zaprojektowane dla długoterminowego wzrostu wartości.',
    clientFocused: 'Orientacja na klienta',
    clientFocusedDesc: 'Spersonalizowana obsługa dostosowana do Twoich unikalnych celów inwestycyjnych.',
    ourApproach: 'Nasze podejście',
    expertVerification: 'Weryfikacja ekspercka',
    expertVerificationDesc: 'Każda nieruchomość w naszym portfolio jest osobiście sprawdzona przez nasz doświadczony zespół. Prezentujemy tylko te możliwości, w które sami byśmy zainwestowali.',
    directPartnerships: 'Bezpośrednie partnerstwa',
    directPartnershipsDesc: 'Pracujemy bezpośrednio z renomowanymi deweloperami i właścicielami nieruchomości, zapewniając najlepsze ceny i warunki bez zbędnych pośredników.',
    endToEndSupport: 'Kompleksowe wsparcie',
    endToEndSupportDesc: 'Od wstępnej konsultacji po zarządzanie nieruchomością — zapewniamy kompleksowe wsparcie przez całą Twoją podróż inwestycyjną.',
    investWithConfidence: 'Inwestuj z pewnością',
    investWithConfidenceDesc: 'Dołącz do nas w odkrywaniu wyjątkowych możliwości inwestycyjnych w nieruchomości. Jako aktywni inwestorzy, prezentujemy tylko te obiekty, w które wierzymy i w które sami byśmy zainwestowali.'
  },
  
  // Cases/Properties page
  cases: {
    title: 'Obiekty inwestycyjne',
    subtitle: 'Przeglądaj naszą wyselekcjonowaną ofertę premium nieruchomości w Europie i Azji',
    searchPlaceholder: 'Szukaj według nazwy lub lokalizacji...',
    allRegions: 'Wszystkie regiony',
    allTypes: 'Wszystkie typy',
    villa: 'Willa',
    apartment: 'Apartament',
    clearFilters: 'Wyczyść filtry',
    whyInvest: 'Dlaczego inwestować w',
    showing: 'Pokazano',
    casesCount: 'obiektów',
    noResults: 'Nie znaleziono obiektów spełniających Twoje kryteria.',
    clearAllFilters: 'Wyczyść wszystkie filtry'
  },
  
  // FAQ page
  faq: {
    title: 'Często zadawane pytania',
    subtitle: 'Znajdź odpowiedzi na najczęstsze pytania dotyczące inwestowania z Fundora',
    stillHaveQuestions: 'Nadal masz pytania?',
    stillHaveQuestionsDesc: 'Nasz zespół jest gotowy pomóc. Umów konsultację, a odpowiemy na wszystkie Twoje pytania.',
    contactUs: 'Skontaktuj się z nami',
    questions: {
      q1: 'Czym jest Fundora?',
      a1: 'Fundora to międzynarodowa marka pośrednicząca w inwestycjach w nieruchomości, łącząca inwestorów z wysokiej jakości obiektami w Europie i Azji. Jesteśmy zarejestrowani na Litwie (UE) od 1998 roku.',
      q2: 'Czy mogę inwestować w nieruchomości za granicą?',
      a2: 'Tak! Specjalizujemy się w pomocy międzynarodowym inwestorom w nabywaniu nieruchomości w na Cyprze Północnym, w Indonezji, Wietnamie i na Malediwach. Nasz zespół zajmuje się wszystkimi zawiłościami transakcji transgranicznych.',
      q3: 'Czy mogę kupić nieruchomość zdalnie?',
      a3: 'Oczywiście. Umożliwiamy zakupy zdalne z kompleksowymi wirtualnymi wycieczkami, wsparciem prawnym i bezpiecznymi procesami płatności. Wielu naszych klientów z powodzeniem inwestuje bez osobistej wizyty na miejscu.',
      q4: 'Czym Fundora różni się od innych?',
      a4: 'Łączymy ponad 10 lat międzynarodowego doświadczenia inwestycyjnego ze starannie zweryfikowaną siecią partnerów. Prezentujemy tylko te obiekty, w które wierzymy, i zapewniamy, że wszystkie płatności trafiają bezpośrednio do deweloperów dla maksymalnego bezpieczeństwa.',
      q5: 'Jak mogę zaufać Fundora?',
      a5: 'Zaufanie to nasz fundament. Wszystkie płatności trafiają bezpośrednio do deweloperów nieruchomości, nigdy przez pośredników. Zapewniamy pełną przejrzystość, wsparcie prawne i mamy udokumentowaną historię od 1998 roku.',
      q6: 'Czy zarządzacie nieruchomościami?',
      a6: 'Tak, współpracujemy z zaufanymi lokalnymi firmami zarządzającymi nieruchomościami w zakresie konserwacji, wynajmu i bieżącej opieki nad Twoją inwestycją.',
      q7: 'Czy Fundora jest tylko dla dużych inwestorów?',
      a7: 'Wcale nie. Pracujemy z inwestorami każdej wielkości — od początkujących kupujących po doświadczonych zarządzających portfelami. Naszą misją jest uczynienie globalnych inwestycji w nieruchomości dostępnymi dla wszystkich.'
    }
  },
  
  // Contact page
  contact: {
    title: 'Umów konsultację',
    subtitle: 'Omówmy Twoje cele inwestycyjne i znajdźmy dla Ciebie idealną nieruchomość',
    getInTouch: 'Skontaktuj się z nami',
    fullName: 'Imię i nazwisko',
    fullNamePlaceholder: 'Jan Kowalski',
    email: 'Adres e-mail',
    emailPlaceholder: 'jan@przyklad.pl',
    phone: 'Numer telefonu',
    phonePlaceholder: '+48 123 456 789',
    interestedRegion: 'Interesujący region',
    selectRegion: 'Wybierz region',
    northernCyprus: 'Cypr Północny',
    indonesia: 'Indonezja',
    vietnam: 'Wietnam',
    maldives: 'Malediwy',
    multipleRegions: 'Wiele regionów',
    upcomingTitle: 'Najbliższe konsultacje',
    nextConsultation: 'Następna konsultacja',
    upcomingSubtitle: 'Zarezerwuj miejsce na jednej z najbliższych konsultacji inwestycyjnych online',
    onlineConsultation: 'Konsultacja inwestycyjna online',
    reserve: 'Zarezerwuj',
    indonesiaFull: 'Bali, Indonezja',
    pickDate: 'Wybierz datę konsultacji',
    pickDateDesc: 'Dostępne konsultacje online dla tego regionu',
    consultationDate: 'Data konsultacji',
    selectDate: 'Wybierz datę',
    changeDate: 'Zmień',
    noDates: 'Brak zaplanowanych terminów — skontaktujemy się, aby ustalić termin',
    continueAnyway: 'Kontynuuj',
    regTitle: 'Zarezerwuj miejsce',
    regSubtitle: 'Kilka danych i Twoje miejsce jest potwierdzone',
    regDetails: 'Informacje o konsultacji',
    regConsultationId: 'ID konsultacji',
    regFormat: 'Format',
    regFormatValue: 'Online przez Google Meet',
    regTimeNote: 'czasu wileńskiego (EET/EEST)',
    regName: 'Imię i nazwisko',
    regEmail: 'Adres e-mail',
    regPhone: 'Numer telefonu',
    regCountry: 'Kraj zamieszkania',
    regCountryPlaceholder: 'Polska',
    regConfirm: 'Potwierdź rejestrację',
    regSubmitting: 'Potwierdzanie...',
    regPrivacy: 'Twoje dane wykorzystujemy wyłącznie do potwierdzenia tej konsultacji. Bez spamu.',
    regThanksTitle: 'Rejestracja potwierdzona',
    regThanksBody: 'Dziękujemy za rejestrację na konsultację inwestycyjną: {{region}}.',
    regThanksEmail: 'Informacje o dołączeniu oraz link do Google Meet zostały wysłane na Twój e-mail. Sprawdź skrzynkę odbiorczą. Jeśli wiadomość nie dotrze w ciągu kilku minut, sprawdź folder spam lub oferty.',
    regThanksClosing: 'Czekamy na spotkanie.',
    regBackHome: 'Powrót na stronę główną',
    regBrowse: 'Przeglądaj projekty',
    regUnavailable: 'Ta konsultacja nie jest już dostępna',
    regUnavailableDesc: 'Termin mógł już minąć. Sprawdź najbliższe konsultacje.',
    regSeeUpcoming: 'Najbliższe konsultacje',
    regError: 'Rejestracja nie powiodła się. Sprawdź dane i spróbuj ponownie.',
    message: 'Wiadomość',
    messagePlaceholder: 'Opowiedz o swoich celach inwestycyjnych i preferencjach...',
    sendMessage: 'Wyślij wiadomość',
    sending: 'Wysyłanie...',
    contactInfo: 'Dane kontaktowe',
    contactInfoDesc: 'Masz pytania? Skontaktuj się z nami dowolnym kanałem, a nasz zespół szybko odpowie.',
    emailLabel: 'E-mail',
    respondTime: 'Odpowiemy w ciągu 24 godzin',
    phoneLabel: 'Telefon',
    phoneHours: 'Pon-Pt, 9:00 - 18:00',
    office: 'Biuro',
    messageSent: 'Wiadomość wysłana!',
    messageSentDesc: 'Dziękujemy za zainteresowanie. Skontaktujemy się z Tobą w ciągu 24 godzin.',
    error: 'Błąd',
    errorMessage: 'Nie udało się wysłać wiadomości. Spróbuj ponownie.'
  },
  
  // Privacy Policy page
  privacy: {
    title: 'Polityka prywatności',
    subtitle: 'Fundora Real Estate — Polityka prywatności dotycząca zbierania danych',
    effectiveDate: 'Data wejścia w życie: 11 lipca 2025 r.',
    intro: 'Fundora Real Estate („my" lub „nasz") szanuje Twoją prywatność i zobowiązuje się do ochrony Twoich danych osobowych. Niniejsza Polityka prywatności wyjaśnia, w jaki sposób zbieramy, wykorzystujemy, przechowujemy i chronimy informacje, które podajesz odpowiadając na nasze reklamy lub przesyłając dane przez formularze leadów na Facebooku lub Instagramie.',
    section1Title: '1. Jakie informacje zbieramy',
    section1Text: 'Gdy wchodzisz w interakcję z naszą kampanią reklamową i dobrowolnie wypełniasz formularz, możemy zbierać następujące dane osobowe:',
    section1List: ['Imię i nazwisko', 'Adres e-mail', 'Numer telefonu'],
    section1Footer: 'Zbieramy te dane wyłącznie w celach opisanych poniżej i tylko za Twoją zgodą.',
    section2Title: '2. Jak wykorzystujemy Twoje informacje',
    section2Text: 'Wykorzystujemy Twoje dane osobowe w następujących celach:',
    section2List: [
      'Aby skontaktować się z Tobą w sprawie możliwości inwestycyjnych w nieruchomości, które mogą Cię zainteresować',
      'Aby dostarczać spersonalizowane informacje i aktualizacje dotyczące naszych usług',
      'Aby odpowiadać na Twoje zapytania lub wnioski',
      'Aby spełniać wszelkie zobowiązania prawne'
    ],
    section2Footer: 'Twoje informacje nie będą sprzedawane, wynajmowane ani udostępniane osobom trzecim w celach marketingowych.',
    section3Title: '3. Podstawa prawna przetwarzania',
    section3Text: 'Przetwarzanie Twoich danych osobowych opiera się na Twojej wyraźnej zgodzie, którą wyrażasz przesyłając dane przez formularz leadów. Możesz wycofać zgodę w dowolnym momencie, kontaktując się z nami (patrz Sekcja 6).',
    section4Title: '4. Przechowywanie danych',
    section4Text: 'Będziemy przechowywać Twoje dane osobowe tylko tak długo, jak jest to niezbędne do realizacji celów określonych w niniejszej polityce lub zgodnie z wymogami obowiązującego prawa. Jeśli wycofasz zgodę, Twoje informacje zostaną niezwłocznie usunięte lub zanonimizowane.',
    section5Title: '5. Bezpieczeństwo danych',
    section5Text: 'Wdrażamy odpowiednie środki techniczne i organizacyjne w celu ochrony Twoich danych osobowych przed nieautoryzowanym dostępem, ujawnieniem, zmianą lub zniszczeniem. Dostęp do Twoich danych mają wyłącznie upoważnieni pracownicy.',
    section6Title: '6. Twoje prawa',
    section6Text: 'Masz prawo do:',
    section6List: [
      'Dostępu do danych osobowych, które przechowujemy na Twój temat',
      'Żądania poprawienia nieprawidłowych danych',
      'Żądania usunięcia Twoich danych',
      'Wycofania zgody w dowolnym momencie',
      'Złożenia skargi do organu ochrony danych, jeśli uważasz, że Twoje prawa zostały naruszone'
    ],
    section6Footer: 'Aby skorzystać z któregokolwiek z tych praw, skontaktuj się z nami:',
    section7Title: '7. Platformy zewnętrzne',
    section7Text: 'Niniejsza Polityka prywatności dotyczy wyłącznie danych zebranych za pośrednictwem formularzy leadów na Facebooku i Instagramie. Pamiętaj, że Facebook i Instagram należą do Meta Platforms, Inc., a korzystanie z tych platform podlega również Polityce danych Meta, dostępnej pod adresem:',
    section7Footer: 'Nie ponosimy odpowiedzialności za praktyki przetwarzania danych przez Meta, ale zapewniamy, że nasze wykorzystanie Twoich danych jest zgodne z politykami ich platformy.',
    section8Title: '8. Aktualizacje tej polityki',
    section8Text: 'Możemy okresowo aktualizować niniejszą Politykę prywatności. Wszelkie zmiany zostaną opublikowane tutaj z zaktualizowaną „Datą wejścia w życie". Zachęcamy do okresowego przeglądania tej polityki.',
    section8Footer: 'Jeśli masz pytania lub wątpliwości dotyczące niniejszej Polityki prywatności, skontaktuj się z nami pod powyższym adresem e-mail.',
    questionsTitle: 'Pytania dotyczące naszej Polityki prywatności?',
    questionsText: 'Jeśli masz pytania lub wątpliwości, nie wahaj się z nami skontaktować.'
  },
  
  // Newsletter component
  newsletter: {
    title: 'Bądź na bieżąco z nowymi możliwościami',
    subtitle: 'Zapisz się, aby otrzymywać ekskluzywne oferty nieruchomości, analizy rynku i porady inwestycyjne prosto na swoją skrzynkę.',
    placeholder: 'Wpisz swój e-mail',
    subscribe: 'Zapisz się',
    subscribing: 'Zapisywanie...',
    subscribed: 'Zapisano!',
    subscribedDesc: 'Dziękujemy za zapisanie się do naszego newslettera.',
    error: 'Błąd',
    errorMessage: 'Nie udało się zapisać. Spróbuj ponownie.'
  },
  
  // Footer
  footer: {
    description: 'Łączymy inwestorów z najlepszymi możliwościami nieruchomości w Europie i Azji od 1998 roku.',
    quickLinks: 'Szybkie linki',
    ourRegions: 'Nasze regiony',
    contact: 'Kontakt',
    copyright: '© {{year}} Fundora. Wszelkie prawa zastrzeżone.'
  },
  
  // Property Card
  property: {
    featured: 'Polecane',
    apartments: 'Apartamenty',
    villas: 'Wille',
    beds: 'Sypialnie',
    baths: 'Łazienki',
    from: 'Od',
    villa: 'Willa',
    apartment: 'Apartament',
    mixed: 'Mieszany',
    studio: 'Studio',
    terrace: 'taras',
    balcony: 'balkon'
  },
  
  // Property Descriptions
  properties: {
    1: {
      description: 'To nowoczesny kompleks z koncepcją „WSZYSTKO W JEDNYM", gdzie wszystko, czego potrzebujesz, jest zebrane w jednym miejscu. Koncepcja „Wszystko w jednym" pozwala cieszyć się restauracjami, zakupami, rozrywką i aktywnościami bez wychodzenia z kompleksu!'
    },
    2: {
      description: 'Dobrze rozwinięta infrastruktura kompleksu tworzy komfortowe warunki do życia i wypoczynku, zwiększając atrakcyjność nieruchomości zarówno do zamieszkania, jak i do inwestycji.'
    },
    3: {
      description: 'Wulkany są jedną z najbardziej charakterystycznych cech krajobrazu Bali, otoczone licznymi mitami i legendami, które wciąż przyciągają setki tysięcy turystów z całego świata, aby doświadczyć ducha gór. W tym projekcie uwagę poświęcono skale wulkanicznej i wielowarstwowemu oświetleniu, odzwierciedlającemu imponującą i dynamiczną naturę erupcji wulkanu.'
    },
    4: {
      description: 'Apartamenty — duży popyt zarówno na mieszkanie, jak i wynajem. Tylko 300 m lub 3 minuty spacerem do popularnych plaż i klubów Finns i Atlas. Berawa — najbardziej pożądana okolica na Bali z dużym ruchem turystycznym. Duży kompleks z infrastrukturą i dachem z panoramicznymi widokami. Wysoka płynność i stabilny wzrost cen.'
    },
    6: {
      description: 'Ekskluzywny kompleks hotelowy położony w pierwszej linii oceanu, otoczony lagunami z krystalicznie czystą wodą. Każda jednostka oferuje malownicze widoki z bezpośrednim widokiem na ocean i zachody słońca.'
    },
    7: {
      description: 'Nadmorska dzielnica miejska w centrum tętniącego życiem miasta. To drugi dom dla milionów Wietnamczyków kochających morze. Solidne miasto o powierzchni 44 ha, górujące nad Zatoką Rajskiego Raju, obiecujące świetlaną przyszłość dla północnej podróży.'
    },
    8: {
      description: 'To nie tylko nieruchomość — to starannie zaprojektowany kompleks mieszkalny, w pełni dostosowany do lokalnej kultury i zasad religijnych. Takie unikalne rozwiązanie zapewnia stały popyt i czyni ten projekt wyjątkową okazją inwestycyjną na wyspie.'
    },
    9: {
      description: 'Zaledwie 100 metrów od plaży, MALIBU oferuje niezrównany dostęp do wybrzeży Morza Śródziemnego. Położony w Esentepe, kompleks łączy naturalne piękno ze współczesną wygodą.'
    },
    12: {
      description: 'Stabilny projekt inwestycyjny z zarządzaniem hotelowym, gwarantowanym modelem i rozwiniętą infrastrukturą — odpowiedni zarówno do generowania dochodu, jak i długoterminowego wzrostu wartości.'
    }
  },
  
  // Property Detail Page
  propertyDetail: {
    backToCases: 'Powrót do obiektów',
    price: 'Cena',
    keyDetails: 'Kluczowe informacje',
    location: 'Lokalizacja',
    propertyType: 'Typ nieruchomości',
    address: 'Adres',
    description: 'O tej nieruchomości',
    interested: 'Zainteresowany tą nieruchomością?',
    getAdvice: 'Uzyskaj spersonalizowaną poradę i dowiedz się, jak ta nieruchomość pasuje do Twoich celów inwestycyjnych.',
    directPayments: 'Bezpośrednie płatności do deweloperów',
    legalSupport: 'Pełne wsparcie prawne',
    remoteAvailable: 'Możliwość zakupu zdalnego',
    browseMore: 'Przeglądaj wszystkie obiekty',
    notFound: 'Nieruchomość nie znaleziona'
  },
  
  // Regions
  regions: {
    northernCyprus: {
      name: 'Cypr Północny',
      nameAccusative: 'Cypr Północny',
      description: 'Nowoczesne apartamenty i studia z możliwościami inwestycyjnymi',
      count: '3 obiekty',
      investmentInfo: 'Cypr Północny łączy oszałamiające wybrzeże Morza Śródziemnego z nieskażonym naturalnym pięknem w cenach znacznie niższych niż na Cyprze Południowym i w Europie Zachodniej. Rosnący sektor turystyczny i wzrastające międzynarodowe uznanie tworzą silny potencjał wzrostu kapitału. Z pięknymi plażami, górskimi krajobrazami i prostym procesem zakupu dla obcokrajowców, to coraz popularniejszy wybór dla inwestorów szukających dostępnego śródziemnomorskiego luksusu.'
    },
    bali: {
      name: 'Bali (Indonezja)',
      nameAccusative: 'Bali (Indonezję)',
      description: 'Wille i apartamenty tropikalnego raju na Bali',
      count: '4 obiekty',
      investmentInfo: 'Rynek nieruchomości na Bali oferuje wyjątkowe zwroty dzięki całorocznemu turystyce i kwitnącej społeczności cyfrowych nomadów. Unikalna kultura wyspy, przystępne koszty życia i tropikalny klimat przyciągają co roku miliony odwiedzających, zapewniając stabilny popyt na wynajem. Indonezyjskie przepisy dotyczące nieruchomości preferują długoterminowe umowy dzierżawy, które zapewniają bezpieczeństwo przy zachowaniu przystępnej ceny wejścia dla międzynarodowych inwestorów.'
    },
    vietnam: {
      name: 'Wietnam',
      nameAccusative: 'Wietnam',
      description: 'Nowoczesne apartamenty i luksusowe projekty',
      count: '1 obiekt',
      investmentInfo: 'Szybko rozwijająca się gospodarka Wietnamu i formująca się klasa średnia tworzą wysoki popyt na wysokiej jakości mieszkania. Nadmorskie miasta, takie jak Nha Trang, oferują nieruchomości przy plaży w atrakcyjnych cenach ze znacznym potencjałem wzrostu. Stabilność polityczna kraju, poprawiająca się infrastruktura i rosnące inwestycje zagraniczne czynią go jednym z najbardziej obiecujących rynków nieruchomości w Azji Południowo-Wschodniej.'
    },
    maldives: {
      name: 'Malediwy',
      nameAccusative: 'Malediwy',
      description: 'Ultra-luksusowe nieruchomości wyspiarskie i inwestycje kurortowe',
      count: '1 obiekt',
      investmentInfo: 'Malediwy reprezentują szczyt luksusowych tropikalnych nieruchomości z ekskluzywnymi obiektami kurortowymi i projektami przy oceanie. Jako jedna z głównych destynacji turystycznych świata, nieruchomości tutaj cieszą się popytem wśród ultrazamożnych klientów i zapewniają wyjątkowe dochody z wynajmu. Skupienie rządu na zrównoważonej turystyce i ograniczone możliwości zabudowy gwarantują ekskluzywność i długoterminowy wzrost wartości.'
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      lt: { translation: ltTranslations },
      ru: { translation: ruTranslations },
      pl: { translation: plTranslations }
    },
    lng: localStorage.getItem('i18nextLng') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage']
    }
  });

export default i18n;
